// import logo from "./logo.svg";
import pp from "./pp.png";
import "./App.css";
import Component from "./Component";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <img src={pp} className="App-logo-PNG" alt="logo" />

        {/* <Component /> */}
        <h1>Punto Python</h1>
        <h2>[Programación, Technología]</h2>
      </header>
    </div>
  );
}

export default App;
